import React, { Suspense, lazy, Fragment } from 'react';
import { Router, Route, Switch } from 'dva/router';
import { ConfigProvider, Spin, Layout } from 'antd';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import dynamic from 'dva/dynamic';
import './index.less';
import LayoutHeader from './layout-header';
import RouterList from './router-list';
import { useShouldReload } from '../hooks/useShouldReload';

const { Content } = Layout;
const Login = lazy(() => import('@pages/login'));
const GoodsLog = lazy(() => import('@pages/goods/list/log'));
const GoodsMaterialView = lazy(() => import('@pages/goods/material-view'));
const TradingOrderDetail = lazy(() => import('@pages/trading/order/order-detail'));
const TradingRefundDetail = lazy(() => import('@pages/trading/refund/detail'));
const TradingReturnDetail = lazy(() => import('@pages/trading/return-goods/detail'));
const CouponsSendList = lazy(() => import('@pages/operation/coupons/sending'));
const BuyerDetail = lazy(() => import('@pages/buyers/management/detail'));
const GiftDetail = lazy(() => import('@pages/trading/gift/detail'));
const GoodsListDetail = lazy(() => import('@pages/goods/list/detail'));
const GiftActivityLogs = lazy(() => import('@pages/operation/gift-activity/logs'));
const GrayWhiteList = lazy(() => import('@pages/system/gray-test/white-list'));

const GoodsNoDeliver = lazy(() => import('@pages/goods/no-deliver'));
const DynamicDataWindow = lazy(() => import('@pages/goods/list/dynamic-data-window'));
const NotFound = lazy(() => import('@pages/not-found'));

// 设置默认的加载组件
dynamic.setDefaultLoadingComponent(() => {
  return <Spin size="large" />;
});

function RouterConfig({ history }) {
  const { isReloading } = useShouldReload();

  if (isReloading) {
    return <div></div>;
  }

  return (
    <Suspense fallback>
      <ConfigProvider locale={zhCN}>
        <Router history={history}>
          <Switch>
            <Route path="/login" component={props => <Login {...props} />} />

            <Route exact path="/not-found" component={props => <NotFound {...props} />} />

            <Route path="/goods/list/log/:id?" component={props => <GoodsLog {...props} />} />
            <Route path="/goods/material-view/:id" component={props => <GoodsMaterialView {...props} />} />
            <Route path="/goods/dynamic-data/:goods_basicid" component={props => <DynamicDataWindow {...props} />} />

            <Route path="/trading/order/detail/:id" component={props => <TradingOrderDetail {...props} />} />
            <Route path="/trading/refund/detail/:id" component={props => <TradingRefundDetail {...props} />} />
            <Route path="/trading/return/detail/:id" component={props => <TradingReturnDetail {...props} />} />
            <Route path="/operation/coupons/sending/:id" component={props => <CouponsSendList {...props} />} />
            <Route path="/trading/gift-detail/:id" component={props => <GiftDetail {...props} />} />
            <Route path="/system/gray-test/white-list/:id" component={props => <GrayWhiteList {...props} />} />

            <Route path="/operation/gift-activity/log/:id" component={props => <GiftActivityLogs {...props} />} />

            <Route exact path="/buyers/management/detail/:id" component={props => <BuyerDetail {...props} />} />

            <Route exact path="/goods/list/detail/:id?/:step?" component={props => <GoodsListDetail {...props} />} />
            <Route
              exact
              path="/goods/no-deliver-area/:goods_basicid"
              component={props => <GoodsNoDeliver {...props} />}
            />

            <Fragment>
              <Layout className="main-layout">
                <LayoutHeader />
                <Layout>
                  <Content className="right-layout">
                    <RouterList />
                  </Content>
                </Layout>
              </Layout>
            </Fragment>
          </Switch>
        </Router>
      </ConfigProvider>
    </Suspense>
  );
}

export default RouterConfig;
